export enum PostMessageType {
  UPDATE_HEIGHT = 'setIframeHeight',
  PLAY_NUMBERS = 'playNumbers',
  RESET_NUMBERS = 'resetNumbers'
}

export default class PostMessageService {
  public static send(body: any) {
    window.parent.postMessage(body, '*')
  }
}
